import { render, staticRenderFns } from "./EcommerceYoYComparison.vue?vue&type=template&id=138cb43c"
import script from "./EcommerceYoYComparison.vue?vue&type=script&lang=js"
export * from "./EcommerceYoYComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports